import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapAuthenticationAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.auth?.updateAppBasicInfo, currentState.auth?.updateAppBasicInfo, {
    successEventName: "authentication_configuration_enabled_user_name",
    trackedEventNames: ["authentication_configuration_enabled_user_name"]
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.setAppFeatures, currentState.platformConfiguration?.setAppFeatures, {
    successEventName: "authentication_configuration_enabled_phone",
    trackedEventNames: ["authentication_configuration_enabled_phone"]
  }),
  ...mapStaticMutation(previousState.passkey, currentState.passkey, {
    successEventName: "authentication_configuration_configured_passkey_successfully",
    trackedEventNames: ["authentication_configuration_enabled_passkey", "authentication_configuration_configured_passkey_successfully", "authentication_configuration_disabled_passkey"]
  })
];
